





































































import { renderTemplate } from "@/lib/utility/renderTemplate";
import DocumentTemplateMixin from "@/mixins/DocumentTemplateMixin.vue";
import { ISignDocument } from "@/models/sign-document.entity";
import { SignDocumentTokenDtoGen } from "@/services/sign/v1/data-contracts";
import { DocumentTemplateModule } from "@/store/modules/document-template.store";
import { PartnerModule } from "@/store/modules/partner";
import DocumentDetailCardEditor from "@/views/sign/DocumentDetailCardEditor.vue";
import DocumentDetailEditorMixin from "@/views/sign/DocumentDetailEditorMixin.vue";
import DocumentDetailMixin from "@/views/sign/DocumentDetailMixin.vue";
import DocumentTemplateDetailTokenForm from "@/views/sign/DocumentTemplateDetailTokenForm.vue";
import DocumentTemplateDetailTokenList from "@/views/sign/DocumentTemplateDetailTokenList.vue";
import { TextFieldConfig } from "@/lib/signature-token.utils";
import DocumentTemplateDetailTokenListKeyboardInstructions from "@/views/sign/DocumentTemplateDetailTokenListKeyboardInstructions.vue";
import DocumentTemplateDetailTokenListOptions from "@/views/sign/DocumentTemplateDetailTokenListOptions.vue";
import DocumentTemplateDetailTokenListOptionsMobile from "@/views/sign/DocumentTemplateDetailTokenListOptionsMobile.vue";
import { debounce } from "debounce";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref } from "vue-property-decorator";

@Component({
  components: {
    DocumentDetailCardEditor,
    DocumentTemplateDetailTokenList,
    DocumentTemplateDetailTokenListOptions,
    DocumentTemplateDetailTokenListOptionsMobile,
    DocumentTemplateDetailTokenForm,
    DocumentTemplateDetailTokenListKeyboardInstructions
  }
})
export default class SignDocumentEditor extends mixins(
  DocumentDetailEditorMixin,
  DocumentDetailMixin,
  DocumentTemplateMixin
) {
  @Prop()
  value!: ISignDocument;

  @Prop()
  loading!: boolean;
  get isLoading() {
    return this.loading;
  }
  set isLoading(loading: boolean) {
    this.$emit("update:loading", loading);
  }

  @Prop()
  valid!: boolean;
  get isValid() {
    return this.valid;
  }
  set isValid(disabled: boolean) {
    this.$emit("update:valid", disabled);
  }

  @Prop()
  height!: string;

  @Ref("detailCardEditor")
  detailCardEditor!: DocumentDetailCardEditor;

  @Prop({ default: false })
  readonly?: boolean;

  snackbar = true;

  key = 0;

  edit = 0;

  currentPageNumber = 0;

  debounceOnResize = debounce(this.onResize, 100, false);

  get isSelectedItem() {
    return DocumentTemplateModule.highlightedToken >= 0;
  }

  get page() {
    return this.pages[this.currentPageNumber];
  }

  get documentTokens() {
    return DocumentTemplateModule.documentTokens;
  }

  get pageTokens() {
    return this.documentTokens[this.currentPageNumber];
  }

  get currentDocumentToken() {
    return this.documentTokens[this.currentPageNumber];
  }

  get isMobile() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get partner() {
    return PartnerModule.partner;
  }

  async mounted() {
    this.isLoading = true;
    await this.initialize(this.value);

    for (const documentTokenPage of this.value.tokens) {
      for (const documentToken of documentTokenPage) {
        let input = documentToken.value ?? "";
        if (!input && documentToken.token !== TextFieldConfig.token) {
          input = renderTemplate(documentToken.token, {
            partner: this.partner
          });
        }

        documentToken.value = input;
      }
    }

    this.isValid = true;
    this.isLoading = false;
  }

  resetHighlighted() {
    DocumentTemplateModule.setHighlightedToken(-1);
  }

  setCurrentPage(currentPageNumber: number) {
    this.currentPageNumber = currentPageNumber;
    DocumentTemplateModule.setCurrentPage(this.currentPageNumber);
  }

  onResize() {
    this.key++;
  }

  startAdd() {
    this.detailCardEditor.addToken();
    this.edit = 1;
  }

  startAddSignature() {
    this.detailCardEditor.addToken();
    this.edit = 2;
  }

  remove(e: SignDocumentTokenDtoGen) {
    const index = this.currentDocumentToken.findIndex(t => JSON.stringify(t) === JSON.stringify(e));
    if (index < 0) {
      return;
    }
    this.currentDocumentToken.splice(index, 1);
  }
}
